<header class="sticky top-0 z-50 glass border-b border-black/5 dark:border-white/10">
    <div class="container-p flex items-center justify-between py-4">
        <a href="#about" class="flex items-center gap-3">
            <span class="font-display font-bold text-xl tracking-tight">Sanju</span>
        </a>
        <nav class="hidden md:flex items-center gap-6 font-medium">
            <a href="#about" class="hover:text-[var(--brand)]">About</a>
            <a href="#skills" class="hover:text-[var(--brand)]">Skills</a>
            <a href="#projects" class="hover:text-[var(--brand)]">Projects</a>
            <a href="#experience" class="hover:text-[var(--brand)]">Experience</a>
            <a href="#contact" class="hover:text-[var(--brand)]">Contact</a>
        </nav>
        <div class="flex items-center gap-3">
            <button (click)="toggleTheme()" class="p-2 rounded-full">
                <ng-container *ngIf="isDarkMode; else lightIcon">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-500" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v2m0 14v2m9-9h-2M5 12H3m15.364 6.364l-1.414-1.414M6.05 
        6.05L4.636 4.636m12.728 0l-1.414 1.414M6.05 17.95l-1.414 1.414" />
                    </svg>
                </ng-container>
                <ng-template #lightIcon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-400" fill="none"
                        viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z" />
                    </svg>
                </ng-template>
            </button>
            <a href="https://drive.google.com/file/d/1RByE-xKWnaDS7DOd95uneGhRdplniqCo/view?usp=sharing" download
                class="px-4 py-2 rounded-xl bg-[var(--brand)] text-white hover:opacity-90">Download CV</a>
        </div>
    </div>
</header>